// Utils
import { debounce } from 'ezyvet-fe-helpers';
/**
 * Debounces the setTooltipSettings function and it will only set if there is content.
 *
 * @template C content data type
 * @param {number} delay debounce delay
 * @return {*}  {SetTooltipSettingsDebounced<C>}
 */
export var setTooltipSettingsDebounced = function (delay) {
    return debounce(function (x, y, contentData, getContent, setTooltipSettings) {
        var content = getContent(contentData);
        content &&
            setTooltipSettings({
                x: x,
                y: y,
                content: content,
                isVisible: true,
            });
    }, delay);
};
//# sourceMappingURL=setTooltipSettingsDebounced.js.map